import { render, staticRenderFns } from "./RateOfReturnBarChart.vue?vue&type=template&id=223ad97a"
import script from "./RateOfReturnBarChart.vue?vue&type=script&lang=ts"
export * from "./RateOfReturnBarChart.vue?vue&type=script&lang=ts"
import style0 from "./RateOfReturnBarChart.vue?vue&type=style&index=0&id=223ad97a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports